import React from 'react';
import TextContent from '../_common/TextContent';
import './ModalHeaderTitle.scss';

interface ModalHeaderTitleProps {
    onCancelClick: () => void;
    onBackClick?: () => void;
    title: string;
    load?: string;
    proppantName?: string | null;
    lofa?: string | null | undefined;
    hasBackButton?: boolean | null;
    backButtonTitle?: string | null;
    jobName?: string | null;
    sandPO?: string | null | undefined;
    disabled?: boolean;
}

const ModalHeaderTitle = ({
    title,
    onCancelClick,
    onBackClick,
    load,
    proppantName,
    lofa,
    hasBackButton = false,
    backButtonTitle,
    jobName,
    sandPO,
    disabled,
}: ModalHeaderTitleProps): React.ReactElement => {
    return (
        <div className="ModalHeaderTitle-Container">
            <div className="ModalHeaderTitle-Icon-Container">
                <div
                    className={`ModalHeaderTitle-Back-Button-Container ${
                        disabled ? 'ModalHeaderTitle-Back-Button-Container-Disabled' : ''
                    }`}
                    onClick={onBackClick}
                >
                    {hasBackButton && (
                        <React.Fragment>
                            <i className="material-icons ModalHeaderTitle-Back-Button" onClick={onBackClick}>
                                arrow_back
                            </i>
                            <div className="ModalHeaderTitle-Back-Button-Title">{backButtonTitle}</div>
                        </React.Fragment>
                    )}
                </div>
                <button className="material-icons ModalHeaderTitle-X-Button" onClick={onCancelClick}>
                    close
                </button>
            </div>
            <div className="ModalHeaderTitle-Title">{title}</div>
            <div className="ModalHeaderTitle-LoadsAttribute-Container">
                {load ? (
                    <div className="ModalHeaderTitle-Attribute">
                        {load !== '0' && <TextContent title="Load #:" value={load ? load : ''}></TextContent>}
                        <TextContent title="Proppant:" value={proppantName || ''}></TextContent>
                        <TextContent title="Loading Facility:" value={lofa || ''}></TextContent>
                        {load !== '0' && <TextContent title="Sand PO:" value={sandPO || ''}></TextContent>}
                        {jobName && <TextContent title="Job Name:" value={jobName || ''}></TextContent>}
                    </div>
                ) : (
                    ''
                )}
                <div className="ModalHeaderTitle-Attribute">
                    {load && load === '0' && <TextContent title="Sand PO:" value={sandPO || ''}></TextContent>}
                </div>
            </div>
        </div>
    );
};

export default ModalHeaderTitle;
